export const DEFNAV = 'default'
export const WILDNAV = '*'
